// Account-level "ideal" ghost stroke curves ({boat, erg}) cached in memory.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
let inflight = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn(cache));

export const subscribeIdeal = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const getIdeal = (kind) => cache?.[kind] || null;

export function loadIdealCurves(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = fetch(`${API}/users/ideal-curves`, { credentials: 'include' })
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null)
    .then((data) => { cache = data; inflight = null; notify(); return cache || {}; });
  return inflight;
}

export async function pinIdealCurve(kind, points, meta = {}) {
  const res = await fetch(`${API}/users/ideal-curves/${kind}`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ points, ...meta }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  cache = { ...(cache || {}), [kind]: await res.json() };
  notify();
  return cache[kind];
}

export async function clearIdealCurve(kind) {
  const res = await fetch(`${API}/users/ideal-curves/${kind}`, { method: 'DELETE', credentials: 'include' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const next = { ...(cache || {}) };
  delete next[kind];
  cache = next;
  notify();
}
